import { useQuery } from '@tanstack/react-query';
import { ExtractFnReturnType } from '@/lib/react-query';
import { getConsolidationDataByType } from '@/features/dashboard/api/getConsolidationDataByType.ts';
import { TypesConsolidationData } from '@/types/ConsolidationData.ts';
import { get_evolucao_inadimplencia } from './get_evolucao_inadimplencia';

type QueryFnType = typeof get_evolucao_inadimplencia;

function useEvolucaoInadimplencia(params) {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['get_evolucao_inadimplencia', params.year, params.month],
    queryFn: () => get_evolucao_inadimplencia(params),
  });
}

export { useEvolucaoInadimplencia };
